module.exports = "body {\r\n    background-color:#fff !important;\r\n}\r\n"